import { render } from "./AgentStatus.vue?vue&type=template&id=24ecf4c6&scoped=true"
import script from "./AgentStatus.vue?vue&type=script&lang=js"
export * from "./AgentStatus.vue?vue&type=script&lang=js"

import "./AgentStatus.vue?vue&type=style&index=0&id=24ecf4c6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ecf4c6"]])

export default __exports__